import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import {
  SearchInput as SharedSearchInput,
  SearchInputWrapper,
} from "@/components/editor/themes/shared/search-input";
import { ColorLabels } from "@/components/editor/utils/use-color";

/**
 * Crosby theme search input styles
 */
export const SearchInput = withViewportStyle(SharedSearchInput)`
  ${SearchInputWrapper} {
    border-radius: ${rem(200)};
  }

  input {
    caret-color: ${({ theme }) => theme.colors[ColorLabels.PRIMARY]};
  }
  
  input, button {
    border-radius: ${rem(200)};
  }
`;
